export const UPDATE = 'UPDATE';
export const CLEAR = 'CLEAR';
